import { Card, Stack, Text } from '@mantine/core';
import React from 'react';
import ListFeature from '../../../components/fragments/MerchantResult/ListFeature';
import PropTypes from 'prop-types';

const CardFeatureSummary = ({
  type = 'activation',
  listFeature = [],
  selectedFeature = [],
}) => {
  const features = listFeature.filter(item => selectedFeature
    .includes(item.id));
  return (
    <Card withBorder>
      <Text fw={500} fz={18}>Fitur MAP yang {type === 'activation' ? 'diaktifkan' : 'dinonaktifkan'}</Text>
      <Stack mt="sm">
        {features.map((item, idx) => (
          <ListFeature feature={item.id} isActive={type === 'activation' ? true : false} key={idx+item.id} name={item.menu} withTimeLine={false}/>
        ))}
      </Stack>
    </Card>
  );
};

export default CardFeatureSummary;

CardFeatureSummary.propTypes = {
  listFeature: PropTypes.array,
  selectedFeature: PropTypes.array,
  type: PropTypes.string
};
